// Contact Form
const selectElement = document.getElementById('service-inquiry');
const btnWrapper = document.querySelector('.contact-service-btn--wrapper');
const btns = btnWrapper.querySelectorAll('p');

// Add event listeners to each <p> tag
btns.forEach(btn => {
  btn.addEventListener('click', () => {
    btns.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    selectElement.value = btn.textContent;
  });
});